import React from 'react';
import Image from "../../../elements/Image";
import Button from "../../../form/Button";
import CoverImage from "../../../../assets/images/bg.webp";

const HubBanner = () => {
  return (
    <>
      <div className="relative h-96 overflow-hidden z-0">
        <div className="absolute inset-0 z-[-1] overflow-hidden flex">
          <Image src={CoverImage} alt="no-data" classes="object-cover" />
        </div>
        <div className="flex items-center space-x-2 absolute top-5 right-10">
          <Button buttonIcon={'fa-regular fa-heart'} buttonIconPosition="left" buttonClasses={"!px-0 aspect-square"} />
          <Button buttonIcon={'fa-regular fa-share'} buttonIconPosition="left" buttonClasses={"!px-0 aspect-square"} />
        </div>
      </div>
    </>
  );
};

export default HubBanner;